import React, { useContext, useState } from "react";
import { CircularProgress, Grid, makeStyles } from "@material-ui/core";
import { FurnisherApi, FurnisherDto } from "../../api-clients/api";
import { TextField } from "@fluentui/react";
import { getApiUrl } from "../../api-clients";
import { AppContext } from "../../contexts/AppContext";
import { SchoolContext } from "../../contexts/SchoolContext";
import FormButtons from "../Shared/FormButtons";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
  wrapper: {
    margin: theme.spacing(1),
    position: "relative",
  },
}));

interface IProps {
  furnisher: FurnisherDto;
  furnisherChanged?: () => void;
}
export default function CRUDFurnisher({
  furnisher,
  furnisherChanged,
}: IProps) {
  const classes = useStyles();
  const { t } = useTranslation();
  const { openSnackbar } = useContext(AppContext);
  const { setFurnisherUpdated } = useContext(SchoolContext);
  const [saving, setSaving] = useState<boolean>(false);
  const [furnisherApi] = useState<FurnisherApi>(new FurnisherApi(getApiUrl()));
  const [newFurnisher, setNewFurnisher] = useState<FurnisherDto>(
    furnisher ?? ({} as FurnisherDto)
  );

  const canSave: boolean = (newFurnisher.name?.length ?? 0) > 0;

  const saveFurnisher = () => {
    setSaving(true);

    if (newFurnisher.furnisherId)
      furnisherApi
        .furnisherPut(newFurnisher)
        .then(() => {
          setSaving(false);
          openSnackbar(t("furnishers.updateSuccess"), "success");
          setFurnisherUpdated(true);
          if (furnisherChanged) furnisherChanged();
        })
        .catch((err) => {
          setSaving(false);
          openSnackbar(t("common.errorOccurred"), "error");
        });
    else
      furnisherApi
        .furnisherPost(newFurnisher)
        .then(() => {
          setSaving(false);
          openSnackbar(t("furnishers.saveSuccess"), "success");
          setNewFurnisher({ name: "" } as FurnisherDto);
          setFurnisherUpdated(true);
          if (furnisherChanged) furnisherChanged();
        })
        .catch((err) => {
          setSaving(false);
          openSnackbar(t("common.errorOccurred"), "error");
        });
  };

  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <TextField
            required
            autoComplete="off"
            label={t("furnishers.name")}
            placeholder={t("furnishers.namePlaceholder")}
            value={newFurnisher.name}
            onChange={(
              event: React.FormEvent<HTMLInputElement | HTMLTextAreaElement>,
              newValue?: string
            ) =>
              setNewFurnisher({
                ...newFurnisher,
                name: newValue,
              } as FurnisherDto)
            }
          />
        </Grid>
      </Grid>
      <div className={classes.wrapper}>
        <FormButtons
          onConfirmClick={saveFurnisher}
          disabled={saving || !canSave}
          cancelButtonVisible={false}
          confirmIcon={newFurnisher.furnisherId != null ? "Save" : "Add"}
          confirmText={
            newFurnisher.furnisherId != null
              ? t("common.save")
              : t("common.create")
          }
        />
        {saving && (
          <CircularProgress
            size={24}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              marginTop: -12,
              marginLeft: -12,
            }}
          />
        )}
      </div>
    </div>
  );
}
